class ProductSubscription extends HTMLElement {
  connectedCallback() {
    const closestSection = this.closest('.shopify-section, dialog');

    this.addEventListener('change', this.onChangePlanId);
    this.addEventListener('click', this.onClick);
    closestSection?.addEventListener('variant:update', this.onVariantUpdate);
    this.updateSelectedState();
  }

  disconnectedCallback() {
    const closestSection = this.closest('.shopify-section, dialog');

    this.removeEventListener('change', this.onChangePlanId);
    this.removeEventListener('click', this.onClick);
    closestSection?.removeEventListener('variant:update', this.onVariantUpdate);
  }

  onChangePlanId = (e) => {
    if (!(e.target instanceof HTMLInputElement) || e.target.name !== 'selling_plan') return;

    e.preventDefault();

    const price = e.target.dataset.price;
    const currentPrices = document.querySelectorAll('#subscription-price');

    currentPrices.forEach((currentPrice) => {
      currentPrice.textContent = price;
    });

    this.updateSelectedState();
  };

  onClick = (e) => {
    if (!(e.target instanceof Element)) return;
    if (!e.target.closest('[data-select-first-selling-plan]')) return;
    if (e.target.closest('.product-subscription__frequency')) return;

    const firstAvailablePlan = this.querySelector('input[name="selling_plan"][value]:not([value=""]):not(:disabled)');

    if (!(firstAvailablePlan instanceof HTMLInputElement)) return;

    firstAvailablePlan.checked = true;
    firstAvailablePlan.dispatchEvent(new Event('change', { bubbles: true }));
  };

  onVariantUpdate = (event) => {
    if (event.detail.data.newProduct) {
      this.dataset.productId = event.detail.data.newProduct.id;
    } else if (event.detail.data.productId !== this.dataset.productId) {
      return;
    }

    const newSubscription = event.detail.data.html.querySelector('product-subscription');

    if (!newSubscription) return;

    this.innerHTML = newSubscription.innerHTML;
    this.updateSelectedState();
  };

  updateSelectedState() {
    const checkedPlan = this.querySelector('input[name="selling_plan"]:checked');
    const hasSubscriptionSelected = checkedPlan instanceof HTMLInputElement && checkedPlan.value !== '';

    this.classList.toggle('has-subscription-selected', hasSubscriptionSelected);
  }
}

if (!customElements.get('product-subscription')) {
  customElements.define('product-subscription', ProductSubscription);
}
